import {
  CONTENT_TYPE_CHANGED,
  BRAND_CHANGED,
  INTERVAL_CHANGED,
  FIELD_CHANGED,
  FETCH_BRANDS_AGGREGATES,
  FETCH_BRANDS_AGGREGATES_SUCCESS,
  FETCH_BRANDS_AGGREGATES_FAILURE,
  FETCH_CONTENT_TYPES_AGGREGATES,
  FETCH_CONTENT_TYPES_AGGREGATES_SUCCESS,
  FETCH_CONTENT_TYPES_AGGREGATES_FAILURE,
  FETCH_DOCUMENTS_AGGREGATES,
  FETCH_DOCUMENTS_AGGREGATES_SUCCESS,
  FETCH_DOCUMENTS_AGGREGATES_FAILURE,
} from './types'

export const contentTypeChanged = (contentType, accessToken) => ({
  type: CONTENT_TYPE_CHANGED,
  payload: { contentType, accessToken },
})

export const brandChanged = (brand, accessToken) => ({
  type: BRAND_CHANGED,
  payload: { brand, accessToken },
})

export const intervalChanged = (interval, accessToken) => ({
  type: INTERVAL_CHANGED,
  payload: { interval, accessToken },
})

export const fieldChanged = (field, accessToken) => ({
  type: FIELD_CHANGED,
  payload: { field, accessToken },
})

export const fetchBrandsAggregates = (contentType, field, interval, accessToken) => ({
  type: FETCH_BRANDS_AGGREGATES,
  payload: { contentType, field, interval, accessToken },
})

export const fetchBrandsAggregatesSuccess = (payload) => ({
  type: FETCH_BRANDS_AGGREGATES_SUCCESS,
  payload,
})

export const fetchBrandsAggregatesFailure = (payload) => ({
  type: FETCH_BRANDS_AGGREGATES_FAILURE,
  payload,
})

export const fetchContentTypesAggregates = (brand, field, interval, accessToken) => ({
  type: FETCH_CONTENT_TYPES_AGGREGATES,
  payload: { brand, field, interval, accessToken },
})

export const fetchContentTypesAggregatesSuccess = (payload) => ({
  type: FETCH_CONTENT_TYPES_AGGREGATES_SUCCESS,
  payload,
})

export const fetchContentTypesAggregatesFailure = (payload) => ({
  type: FETCH_CONTENT_TYPES_AGGREGATES_FAILURE,
  payload,
})

export const fetchDocumentsAggregates = (brand, contentType, field, interval, accessToken) => ({
  type: FETCH_DOCUMENTS_AGGREGATES,
  payload: { brand, contentType, field, interval, accessToken },
})

export const fetchDocumentsAggregatesSuccess = (payload) => ({
  type: FETCH_DOCUMENTS_AGGREGATES_SUCCESS,
  payload,
})

export const fetchDocumentsAggregatesFailure = (payload) => ({
  type: FETCH_DOCUMENTS_AGGREGATES_FAILURE,
  payload,
})
